import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BookOpen18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.1821 7.2276C15.5839 7.12714 15.8282 6.71994 15.7278 6.31809C15.6273 5.91624 15.2201 5.67192 14.8183 5.77238L10.8183 6.77238C10.4164 6.87285 10.1721 7.28005 10.2726 7.68189C10.373 8.08374 10.7802 8.32806 11.1821 8.2276L15.1821 7.2276Z'
      fill='currentColor'
    />
    <path
      d='M15.1821 11.2276C15.5839 11.1271 15.8282 10.7199 15.7278 10.3181C15.6273 9.91624 15.2201 9.67192 14.8183 9.77238L10.8183 10.7724C10.4164 10.8728 10.1721 11.28 10.2726 11.6819C10.373 12.0837 10.7802 12.3281 11.1821 12.2276L15.1821 11.2276Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.1819 1.2724L9 3.22692L16.8181 1.2724C17.284 1.15593 17.75 1.5198 17.75 2V14C17.75 14.3442 17.5158 14.6441 17.1819 14.7276L9.1819 16.7276C9.06247 16.7575 8.93753 16.7575 8.8181 16.7276L0.818098 14.7276C0.484223 14.6441 0.25 14.3442 0.25 14V2C0.25 1.5198 0.716035 1.15593 1.1819 1.2724ZM1.75 2.96059V13.4144L8.25 15.0394L8.25 4.58559L1.75 2.96059ZM9.75 4.58559L9.75 15.0394L16.25 13.4144V2.96059L9.75 4.58559Z'
      fill='currentColor'
    />
  </Svg>
);

BookOpen18.displayName = 'BookOpen18';
export default BookOpen18;
